var FormDensity;
(function (FormDensity) {
    FormDensity["COMPACT"] = "compact";
    FormDensity["CONFORTABLE"] = "confortable";
    FormDensity["DEFAULT"] = "default";
})(FormDensity || (FormDensity = {}));
var FormEditingMode;
(function (FormEditingMode) {
    FormEditingMode["DEFAULT"] = "default";
    FormEditingMode["EXTERNAL"] = "external";
})(FormEditingMode || (FormEditingMode = {}));
export { FormDensity, FormEditingMode, };
//# sourceMappingURL=form-constants.js.map